"use client";

import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/routing/ProtectedRoute";
import RedirectIfAuthed from "@/components/routing/RedirectIfAuthed";
import LandingPage from "@/components/LandingPage";
import FullPageLoader from "@/components/FullPageLoader";
import { ROUTES } from "@/config/routes";

const AuthPage = lazy(() => import("@/components/AuthPage"));
const Dashboard = lazy(() => import("@/components/Dashboard"));
const PricingPage = lazy(() => import("@/components/PricingPage"));
const TemplateGallery = lazy(() => import("@/components/TemplateGallery"));
const AboutUs = lazy(() => import("@/components/AboutUs"));
const ContactUs = lazy(() => import("@/components/ContactUs"));
const PrivacyPolicy = lazy(() => import("@/components/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("@/components/TermsOfUse"));
const ShippingDelivery = lazy(() => import("@/components/ShippingDelivery"));
const CancellationsRefunds = lazy(
  () => import("@/components/CancellationsRefunds")
);
const NotFound = lazy(() => import("@/components/routing/NotFound"));

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<FullPageLoader message="Loading..." />}>
          <Routes>
            <Route element={<Layout />}>
              <Route
                path={ROUTES.HOME}
                element={
                  <RedirectIfAuthed>
                    <LandingPage />
                  </RedirectIfAuthed>
                }
              />
              <Route
                path={ROUTES.AUTH}
                element={
                  <RedirectIfAuthed>
                    <AuthPage />
                  </RedirectIfAuthed>
                }
              />
              <Route
                path={ROUTES.DASHBOARD}
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path={ROUTES.PRICING} element={<PricingPage />} />
              <Route path={ROUTES.TEMPLATES} element={<TemplateGallery />} />
              <Route path={ROUTES.ABOUT} element={<AboutUs />} />
              <Route path={ROUTES.CONTACT} element={<ContactUs />} />
              <Route
                path={ROUTES.PRIVACY_POLICY}
                element={<PrivacyPolicy />}
              />
              <Route path={ROUTES.TERMS_OF_USE} element={<TermsOfUse />} />
              <Route
                path={ROUTES.SHIPPING_DELIVERY}
                element={<ShippingDelivery />}
              />
              <Route
                path={ROUTES.CANCELLATIONS_REFUNDS}
                element={<CancellationsRefunds />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}
